import React from "react";

import { Paragraph } from "@fronterahealth/frontera-ui-components";

import { Loader } from "@components/ClinicalNewReportDialog/Loader";

interface GeneratingReassessmentScreenProps {
  message?: string;
}

export const GeneratingReassessmentScreen: React.FC<GeneratingReassessmentScreenProps> = ({
  message = "Generating your Reassessment",
}) => {
  return (
    <div className="flex h-[calc(100vh-var(--nav-height,0px)-var(--subheader-height,0px)-var(--footer-height,0px))] w-full items-center justify-center bg-limestone-50">
      <div className="flex items-center gap-3">
        <Loader className="m-0 h-5 w-5 text-limestone-300" />
        <Paragraph colorType="secondary">{message}</Paragraph>
      </div>
    </div>
  );
};
